import { Dialog, DialogContent, DialogProps, Typography } from '@mui/material';
import { FC } from 'react';
import { Loading } from '../../../../lib/components';
import { useTranslation } from 'react-i18next';

type Props = {
  text?: string;
} & Pick<DialogProps, 'open'>;

export const LoadingDialog: FC<Props> = ({ open, text }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      maxWidth={'md'}
      PaperProps={{
        className: 'flex flex-col justify-center max-h-[52vh] rounded-lg shadow-900'
      }}
    >
      <DialogContent
        dividers
        sx={{
          borderBottom: (theme) => `6px solid ${theme.palette.heaven.main}`,
          paddingTop: '10px',
          paddingX: '32px',
          paddingY: '24px',
          overflow: 'hidden',
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        <Loading />
        <Typography sx={{ fontWeight: 'bolder', marginTop: '16px' }}>{text}</Typography>
        <Typography sx={{ fontSize: '11pt' }}>{t('custom:patience')}</Typography>
      </DialogContent>
    </Dialog>
  );
};
